import { Injectable } from '@angular/core';
import { FormControl } from '@angular/forms';
import { BasicService } from 'src/app/shared/services/basic.service';
import { CompanyStrategy } from './company-strategy.model';
import { limitationsDictionnary } from './limitations-dictionnary.const';
import { PasswordValidator } from './password.validator';

@Injectable({
  providedIn: 'root',
})
export class PasswordChangeService {
  constructor(private basicService: BasicService) {}

  extractCompanyStrategy(
    email: string,
    companyStrategy: CompanyStrategy,
    passwordCtrl?: FormControl,
    oldPasswordCtrl?: FormControl
  ) {
    if (companyStrategy) {
      const {
        password_has_uppercase,
        password_has_number,
        password_has_lowercase,
        password_nmin_characters,
        password_nmin_special_characters,
      } = companyStrategy;

      const { limitations, introduction } = this.extractLimitations(
        email,
        {
          password_nmin_characters,
          password_nmin_special_characters,
          password_has_uppercase,
          password_has_number,
          password_has_lowercase,
        },
        passwordCtrl,
        oldPasswordCtrl
      );
      return { limitations, introduction };
    }
    return { limitations: [], introduction: null };
  }

  private extractLimitations(
    email: string,
    companyStrategy: CompanyStrategy,
    passwordCtrl?: FormControl,
    oldPasswordCtrl?: FormControl
  ) {
    const {
      password_nmin_characters,
      password_nmin_special_characters,
      password_has_uppercase,
      password_has_number,
      password_has_lowercase,
    } = companyStrategy;
    passwordCtrl.addValidators(
      PasswordValidator.validPassword(
        {
          password_nmin_characters,
          password_nmin_special_characters,
          password_has_uppercase,
          password_has_number,
          password_has_lowercase,
        },
        oldPasswordCtrl
      )
    );

    const limitations = limitationsDictionnary
      .filter(limitation => companyStrategy[limitation.code])
      .map(limitation => {
        let text = this.basicService.translate(limitation.key, { n: companyStrategy[limitation.code] });
        if (limitation.key === 'password-confirm/min-special-characters' && companyStrategy[limitation.code] === 1) {
          text = this.basicService.translate('password-confirm/at-least-one-special-character');
        }
        return { ...limitation, text };
      });
    const introduction = this.basicService.translate('password-confirm/introduction', { email });
    return { limitations, introduction };
  }
}
